/* eslint-disable @trello/export-matches-filename */
/* eslint-disable no-useless-escape */
import { isNull } from 'underscore';

export function isStringInRange(min: number, max: number, error: string) {
  return (value: string) => {
    if (value.length < min || value.length > max) {
      return error;
    }
    return null;
  };
}

export function isValidHttpUrl(error: string) {
  return (value: string) => {
    return /^https?:\/\//.test(value) ? null : error;
  };
}

export function isValidHttpsUrl(error: string) {
  return (value: string) => {
    return /^https:\/\//.test(value) ? null : error;
  };
}

export const EMAIL_REGEX = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

export const URL_REGEX =
  /^http[s]*\:\/\/[wwW]{3}\.+[a-zA-Z0-9]+\.[a-zA-Z]{2,3}.*$|^http[s]*\:\/\/[^w]{3}[a-zA-Z0-9]+\.[a-zA-Z]{2,3}.*$|http[s]*\:\/\/[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}.*$/;

export function isEmailOrUrl(error: string) {
  return (value: string) => {
    return EMAIL_REGEX.test(value) || URL_REGEX.test(value) ? null : error;
  };
}

export function isEmptyOr(next: (value: string) => string | null) {
  return (value: string) => {
    if (isNull(value) || value === '') {
      return null;
    }

    return next(value);
  };
}
